type HrtBookabilityFields = {
  ehrPrimaryAppointmentTypeId?: string[] | null;
  isBookableOnStorefront?: boolean | null;
};

type ConfigFlags = Record<string, boolean> | undefined | null;

const EXPERITY_ORG_ID = 24;

export function isHrtStorefrontBookable(
  hrt: HrtBookabilityFields | null | undefined,
  configFlags: ConfigFlags,
): boolean {
  return (
    !!hrt?.ehrPrimaryAppointmentTypeId?.length &&
    !!hrt?.isBookableOnStorefront &&
    !!configFlags?.Booking
  );
}

export function isOrgExperityBookable(
  orgId: number,
  configFlags: ConfigFlags,
): boolean {
  return !!configFlags?.Booking && orgId === EXPERITY_ORG_ID;
}

export function getBuyNowDestinationPath({
  hrt,
  orgId,
  configFlags,
  clientSlug,
  hrtId,
}: {
  hrt: HrtBookabilityFields | null | undefined;
  orgId: number;
  configFlags: ConfigFlags;
  clientSlug: string;
  hrtId: number | string;
}): string {
  const bookable =
    isHrtStorefrontBookable(hrt, configFlags) ||
    isOrgExperityBookable(orgId, configFlags);
  return `/${clientSlug}/${bookable ? "schedule" : "review"}?hrtId=${hrtId}`;
}
